import styled from "styled-components";

export const StyledList = styled.ul`
    list-style-type: disc;
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin: 0;
    padding: 0 0 0 18px;
`;

export const StyledListItem = styled.li`
    line-height: 16px;
`;
